import { render, staticRenderFns } from "./CbsOrderbyItem.vue?vue&type=template&id=865cff48&scoped=true"
import script from "./CbsOrderbyItem.vue?vue&type=script&lang=js"
export * from "./CbsOrderbyItem.vue?vue&type=script&lang=js"
import style0 from "./CbsOrderbyItem.vue?vue&type=style&index=0&id=865cff48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865cff48",
  null
  
)

export default component.exports